import getOptions from "../../../utils/getOptions";
import aspects from "../../../config/aspects";
import destinations from "../../../config/destinations";

export const groupByDestinationAndAspect = (data = []) => {
  const aspectOrder = aspects;
  const destinationOrder = destinations;
  const destinationMap = new Map();

  data.forEach((item) => {
    if (!destinationMap.has(item.destination)) {
      destinationMap.set(item.destination, new Map());
    }
    const aspectMap = destinationMap.get(item.destination);
    if (!aspectMap.has(item.aspect)) {
      aspectMap.set(item.aspect, []);
    }
    aspectMap.get(item.aspect).push(item);
  });

  const result = [];

  const handleTagging = (item) => {
    if (item?.nonconforming === true) {
      return "ZERO";
    }
    return null;
  };

  const handleDisabling = (item) => {
    if (item?.nonconforming === true) {
      return true;
    }
    return false;
  };

  for (const dest of destinationOrder) {
    if (!destinationMap.has(dest)) continue;

    const aspectMap = destinationMap.get(dest);
    const aspectItems = [];

    for (const aspect of aspectOrder) {
      if (aspectMap.has(aspect)) {
        aspectItems.push({
          aspect,
          items: getOptions(
            aspectMap.get(aspect),
            "name",
            "text",
            handleTagging,
            handleDisabling
          ),
        });
      }
    }

    result.push({
      destination: dest,
      items: aspectItems,
    });
  }

  return result;
};
